import { render, staticRenderFns } from "./ResetNickname.vue?vue&type=template&id=3cf24bac&scoped=true"
import script from "./ResetNickname.vue?vue&type=script&lang=js"
export * from "./ResetNickname.vue?vue&type=script&lang=js"
import style0 from "./ResetNickname.vue?vue&type=style&index=0&id=3cf24bac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf24bac",
  null
  
)

export default component.exports